import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { transformContactsImportFileDataForFrontend } from 'modules/contacts/contacts-import/hook/use-get-preview-of-import-contacts-table/utils';
import { ContactsImportDelimiter } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type';
import { ContactsImportFileDataBackendType } from 'modules/contacts/contacts-import/types/contacts-import-file-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export function useGetPreviewOfImportContactsTable() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.postForm
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = async t2 => {
      const {
        file,
        delimiter
      } = t2;
      ;
      try {
        const formData = {
          importFile: file,
          delimiter
        };
        const data = await fetcher(`${CONTACT_API}/contacts/import/preview`, formData);
        return transformContactsImportFileDataForFrontend({
          dataFromBackend: data
        });
      } catch (t3) {
        const e = t3;
        if (e instanceof BadRequest) {
          if (e.errors.fields.importFile) {
            toast.error(e.errors.fields.importFile.join());
          }
        }
        throw e;
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isFetching || $[4] !== t1) {
    t2 = {
      fetcherGetPreviewOfImportContactsTable: t1,
      isGetPreviewOfImportContactsTableFetching: isFetching
    };
    $[3] = isFetching;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}